
import {alertController, IonButton, IonContent, modalController, popoverController} from '@ionic/vue'
import {defineComponent} from 'vue'
import BoardWriteModal from '@/components/Modal/BoardWriteModal.vue'
import {useStore} from 'vuex'
export default defineComponent({
  components: {IonContent},
  name: 'Popover',
  props: {
    stockItemBoard: null,
    stockItemId: null,
  },
  setup(props) {
    const {getters, dispatch, commit} = useStore()
    const openModal = async (stockItemBoard: any = null) => {
      const modal = await modalController
        .create({
          backdropDismiss: true,
          component: BoardWriteModal,
          componentProps: {
            stockItemBoard: props.stockItemBoard,
            stockItemId: props.stockItemId,
          },
          cssClass: 'board-write-modal',
          id: 'BoardWriteModal',
          keyboardClose: true,
          mode: 'ios',
          swipeToClose: true,
        })
      await popoverController.dismiss()
      return modal.present()
    }

    const dismiss = () => {
      return popoverController.dismiss()
    }

    const deleteBoard = async (stockItemId: number, stockItemBoardId: number) => {
      const ok = await dispatch('stockItem/ACT_DELETE_STOCK_ITEM_BOARD', {
        stockItemBoardId: stockItemBoardId,
        stockItemId: stockItemId,
      })
      if (ok) {
        dismiss()
      }
    }
    const sureDelete = async () => {
      const alert = await alertController
        .create({
          buttons: [
            {
              cssClass: 'btn-gray',
              role: 'cancel',
              text: '취소',
            },
            {
              handler: async () => {
                await deleteBoard(props.stockItemId, props.stockItemBoard.stockItemBoardId)
              },
              text: '삭제하기',
            },
          ],
          cssClass: 'btn-groups lead-alert-class',
          message: `
          <div class="alert_css">
            <div class="header">
              의견을 삭제합니다.
            </div>
            <div class="message">
              삭제후 복구 불가능하며<br/>
              적립된 포인트는 회수됩니다.
            </div>
          </div>`,
        })
      await popoverController.dismiss()
      return alert.present()
    }

    return {openModal, sureDelete}
  },

})
